import React from 'react'
import { Icon } from '@iconify/react'
import { useRef, useState, useEffect } from 'react'
// import editFill from '@iconify/icons-eva/edit-fill'
import archiveOutline from '@iconify/icons-eva/archive-outline'
import { Link as RouterLink } from 'react-router-dom'
import trash2Outline from '@iconify/icons-eva/trash-2-outline'
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill'
// material
import {
  Menu,
  MenuItem,
  IconButton,
  ListItemIcon,
  ListItemText,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Slide,
  TextField,
  Stack
} from '@material-ui/core'

import { useSnackbar } from 'notistack5'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import AppBar from "@mui/material/AppBar";
import CloseIcon from '@mui/icons-material/Close';
/*import TimePicker from 'react-time-picker'*/
//api

import useUser from 'utils/api/users'
import storage from 'utils/storage'

// ----------------------------------------------------------------------
const moment = require('moment-timezone');
moment().tz('Asia/Manila').format();
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

export default function AdminMoreMenu({ id, user, action, data }) {

  const ref = useRef(null)
  const [isOpen, setIsOpen] = useState(false)
  const [open, setOpen] = useState(false)
  const [openArchive, setOpenArchive] = useState(false)
  const [openEdit, setOpenEdit] = useState(false)
  const { enqueueSnackbar } = useSnackbar()
  const [timein, setTimeIn] = useState(null);
  const [breakin, setBreakIn] = useState(null);
  const [breakout, setBreakOut] = useState(null);
  const [timeout, setTimeOut] = useState(null);
  const [timeinActive, setTimeinActive] = useState(false);
  const [breakinActive, setBreakinActive] = useState(false);
  const [breakoutActive, setBreakoutActive] = useState(false);
  const [timeoutActive, setTimeoutActive] = useState(false);
  const [passwordDialog, setPasswordDialog] = useState(false);
  const [password, setPassword] = useState('');
  const [validationErrors, setValidationErrors] = useState({
    timein: false,
    breakin: false,
    breakout: false,
    timeout: false
  });

  

  const renderTime = (_time) => {
    let _date = new Date(_time)
    var hours = _date.getHours()
    var minutes = _date.getMinutes()
    var ampm = hours >= 12 ? 'pm' : 'am'
    hours = hours % 12
    hours = hours ? hours : 12 // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes
    var strTime = hours + ':' + minutes + ' ' + ampm
    return strTime
  }

  const filterByStatus = (_data, type) => {
    let _d = _data.filter((_d) => (_d.status === type ? _d : ''))
    if (_d.length > 0) {
      _d = _d[0]
    }
    if (_d) {
      if(typeof(_d.time) === "string") {
        return {
          time: _d.time === undefined ? 'n/a' : _d.time,
          location: _d.address === undefined ? 'n/a' : _d.address,
          workmate: _d.workmate === undefined ? '' : 'Workmate( ' +_d.workmate + ' )'
        }
      }
      else {
        return {
          time: _d.time === undefined ? 'n/a' : renderTime(_d.time),
          location: _d.address === undefined ? 'n/a' : _d.address,
          workmate: _d.workmate === undefined ? '' : 'Workmate( ' +_d.workmate + ' )'
        }   
      }   
    } else {
      return '-'
    }
  }

  const handleClickOpen = () => {
    setOpen(true)
    setIsOpen(false)
  }

  useEffect(() => {
  	if (data.Records.length <= 0) {
  		const timein = "n/a"
  		const breakin = "n/a"
  		const breakout = "n/a"
  		const timeout = "n/a"
  	}
  	else {
  		const timein = filterByStatus(data.Records[0].record, 'time-in').time
  		const breakin = filterByStatus(data.Records[0].record, 'break-in').time
  		const breakout = filterByStatus(data.Records[0].record, 'break-out').time
  		const timeout = filterByStatus(data.Records[0].record, 'time-out').time
  		
  		// Handle both timestamp and time string formats, convert to Date objects for TimePicker
      const parseTimeValueToDate = (timeValue) => {
        if (timeValue === 'n/a' || timeValue === '-') {
          return null;
        }
        
        // If it's a timestamp (number), convert it to Date object
        if (typeof timeValue === 'number') {
          return new Date(timeValue);
        }
        
        // If it's already a time string, parse it and convert to Date
        if (typeof timeValue === 'string') {
          // Try different parsing formats with moment first
          let parsed = moment(timeValue, 'h:mm a', true);
          if (!parsed.isValid()) {
            parsed = moment(timeValue, 'HH:mm', true);
          }
          if (!parsed.isValid()) {
            parsed = moment(timeValue);
          }
          
          if (parsed.isValid()) {
            return parsed.toDate(); // Convert moment to Date object
          }
        }
        
        return null;
      };

      setTimeIn(parseTimeValueToDate(timein));
      setBreakIn(parseTimeValueToDate(breakin));
      setBreakOut(parseTimeValueToDate(breakout));
      setTimeOut(parseTimeValueToDate(timeout));
      
  	}
  	action("")
      
  }, [])

  const handleClickEdit = () => {

    if (filterByStatus(data.Records[0].record, 'time-in').time === "n/a") {
      setTimeinActive(true)
    }
    if (filterByStatus(data.Records[0].record, 'break-in').time === "n/a") {
      setBreakinActive(true)
    }
    if (filterByStatus(data.Records[0].record, 'break-out').time === "n/a") {
      setBreakoutActive(true)
    }
    if (filterByStatus(data.Records[0].record, 'time-out').time === "n/a") {
      setTimeoutActive(true)
    }
    setOpenEdit(true)
    setIsOpen(false)
  }

  const handleClose = () => {
    setIsOpen(false)
    setOpen(false)
  }

  const handleCloseEdit = () => {
    setOpenEdit(false)
    setOpen(false)
  }

  const handleClickOpenArchive = () => {
    setOpenArchive(true)
    setIsOpen(false)
  }

  const handleCloseArchive = () => {
    setOpenArchive(false)
    setOpen(false)
  }

  const handleClickPasswordOpen = () => {
    setPasswordDialog(true)
    setIsOpen(false)
  }

  const handleClosePasswordDialog = () => {
    setPasswordDialog(false)
    setOpen(false)
  }

  const handleRemove = async () => {
    const local_user = await storage.getUser()
    if (!local_user) {
      setOpen(false)
      return enqueueSnackbar('Unable to process action', { variant: 'error' })
    }

    if (!id) {
      setOpen(false)
      return enqueueSnackbar('Unable to remove the user', { variant: 'error' })
    }

    const user = JSON.parse(local_user)
    const result = await useUser.delete_last_record_by_id(id)

    if (!result.ok) return enqueueSnackbar(result.data.msg, { variant: 'error' })

    enqueueSnackbar('Record deleted success', { variant: 'success' })
    setOpen(false)
    action("delete last record success")
  }

  const handleArchive = async () => {
    const local_user = await storage.getUser()

    if (!local_user) {
      setOpen(false)
      return enqueueSnackbar('Unable to process action', { variant: 'error' })
    }

    if (!id) {
      setOpen(false)
      return enqueueSnackbar('Unable to remove the user', { variant: 'error' })
    }

    const user = JSON.parse(local_user)
    const result = await useUser.delete_record_by_id(id)
    if (!result.ok) return enqueueSnackbar(result.data.msg, { variant: 'error' })

    enqueueSnackbar('Record deleted success', { variant: 'success' })
    action("delere record success")
    setOpen(false)
    setOpenArchive(false)
    
  }

  // Validation function for time format
  const validateTime = (timeValue, fieldName) => {
    if (!timeValue) {
      setValidationErrors(prev => ({ ...prev, [fieldName]: false }));
      return true; // null/empty is valid (optional field)
    }

    // Check if it's a valid Date object
    if (timeValue instanceof Date && !isNaN(timeValue.getTime())) {
      setValidationErrors(prev => ({ ...prev, [fieldName]: false }));
      return true;
    }

    // If it's a string, try to parse it
    if (typeof timeValue === 'string') {
      const timeRegex = /^(1[0-2]|0?[1-9]):[0-5][0-9]\s?(AM|PM|am|pm)$/;
      const isValid = timeRegex.test(timeValue.trim());
      setValidationErrors(prev => ({ ...prev, [fieldName]: !isValid }));
      return isValid;
    }

    setValidationErrors(prev => ({ ...prev, [fieldName]: true }));
    return false;
  };

  // Check if all times are valid
  const areAllTimesValid = () => {
    return !Object.values(validationErrors).some(error => error === true);
  };

  const handleEdit = async () => {

    const local_user = await storage.getUser()

    if (!local_user) {
      setOpenEdit(false)
      return enqueueSnackbar('Unable to process action', { variant: 'error' })
    }

    if (!id) {
      setOpenEdit(false)
      return enqueueSnackbar('Unable to remove the user', { variant: 'error' })
    }

    // Validate all times before submitting
    const timeinValid = validateTime(timein, 'timein');
    const breakinValid = validateTime(breakin, 'breakin');
    const breakoutValid = validateTime(breakout, 'breakout');
    const timeoutValid = validateTime(timeout, 'timeout');

    if (!timeinValid || !breakinValid || !breakoutValid || !timeoutValid) {
      return enqueueSnackbar('Please enter valid time formats (e.g., 7:30 AM)', { variant: 'error' });
    }

    const user = JSON.parse(local_user)
    
    // Convert Date objects to timestamps (milliseconds since epoch) for the backend
    const convertDateToTimestamp = (dateObj) => {
      if (!dateObj || !(dateObj instanceof Date)) {
        return null;
      }
      
      // Create a timestamp using today's date with the time from the Date object
      const today = moment().startOf('day');
      const timeFromDate = moment(dateObj);
      
      // Combine today's date with the selected time
      const fullDateTime = today.clone()
        .hours(timeFromDate.hours())
        .minutes(timeFromDate.minutes())
        .seconds(0)
        .milliseconds(0);
      
      return fullDateTime.valueOf(); // Returns timestamp in milliseconds
    };

    const timeData = {
      timein: convertDateToTimestamp(timein),
      breakin: convertDateToTimestamp(breakin),
      breakout: convertDateToTimestamp(breakout),
      timeout: convertDateToTimestamp(timeout),
      uid: user._id
    }
    const result = await useUser.update_record_by_id(id, timeData)

    if (!result.ok) return enqueueSnackbar(result.data.msg, { variant: 'error' })

    enqueueSnackbar('Record update success', { variant: 'success' })
    action("edit success")
    setOpenEdit(false)
    
  }

  const handleChangePassword = async () => {
    if (password === null || password === "") {
      alert("Please input password")
    }
    else {
      const result = await useUser.update_user_password(user, password)
      if (result.status === 200) {
        alert("Password update success")
        setPasswordDialog(false)    
      }
      else {
        alert("Something went wrong please try again later")
      }

    }
  }

  return (

    <>

      <IconButton ref={ref} onClick={() => setIsOpen(true)}>
        <Icon icon={moreVerticalFill} width={20} height={20} />
      </IconButton>
      {data.Records.length > 0 
        ? 
          <Menu
            open={isOpen}
            anchorEl={ref.current}
            onClose={() => setIsOpen(false)}
            PaperProps={{
              sx: { width: 200, maxWidth: '100%' },
            }}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          >
            <MenuItem component={RouterLink} to="#" sx={{ color: 'text.secondary' }}>
              <ListItemIcon>
                <Icon icon={archiveOutline} width={24} height={24} />
              </ListItemIcon>
              <ListItemText
                primary="Edit Record"
                onClick={handleClickEdit}
                primaryTypographyProps={{ variant: 'body2' }}
              />
            </MenuItem>
            <MenuItem component={RouterLink} to="#" sx={{ color: 'text.secondary' }}>
              <ListItemIcon>
                <Icon icon={archiveOutline} width={24} height={24} />
              </ListItemIcon>
              <ListItemText
                primary="Delete Record"
                onClick={handleClickOpenArchive}
                primaryTypographyProps={{ variant: 'body2' }}
              />
            </MenuItem>
            <MenuItem component={RouterLink} to="#" sx={{ color: 'text.secondary' }}>
              <ListItemIcon>
                <Icon icon={archiveOutline} width={24} height={24} />
              </ListItemIcon>
              <ListItemText
                primary="Delete Last Record"
                onClick={handleClickOpen}
                primaryTypographyProps={{ variant: 'body2' }}
              />
            </MenuItem>
            <MenuItem component={RouterLink} to="#" sx={{ color: 'text.secondary' }}>
              <ListItemIcon>
                <Icon icon={archiveOutline} width={24} height={24} />
              </ListItemIcon>
              <ListItemText
                primary="Reset Password"
                onClick={handleClickPasswordOpen}
                primaryTypographyProps={{ variant: 'body2' }}
              />
            </MenuItem>
          </Menu>   
        : 
        	<Menu
        	  open={isOpen}
        	  anchorEl={ref.current}
        	  onClose={() => setIsOpen(false)}
        	  PaperProps={{
        	    sx: { width: 200, maxWidth: '100%' },
        	  }}
        	  anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        	  transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        	>
		        <MenuItem component={RouterLink} to="#" sx={{ color: 'text.secondary' }}>
		            <ListItemIcon>
		              <Icon icon={archiveOutline} width={24} height={24} />
		            </ListItemIcon>
		            <ListItemText
		              primary="Reset Password"
		              onClick={handleClickPasswordOpen}
		              primaryTypographyProps={{ variant: 'body2' }}
		            />
		        </MenuItem>
	        </Menu>  
      }
     

      <div>
        <Dialog
          open={open}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleClose}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle id="alert-dialog-slide-title">{'Do you wish to proceed with this action?'}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              Once action processed the record will be deleted.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              No
            </Button>
            <Button onClick={handleRemove} color="primary">
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      </div>

      <div>
        <Dialog
          open={openArchive}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleCloseArchive}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle id="alert-dialog-slide-title">{'Do you wish to restore this User?'}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              Once action processed the record will be deleted.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseArchive} color="primary">
              No
            </Button>
            <Button onClick={handleArchive} color="primary">
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      </div>

      <div>
        <Dialog
          open={openEdit}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleCloseEdit}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle id="alert-dialog-slide-title">Edit Record</DialogTitle>
          <DialogContent>
            Time-in:
            <br/> 
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <TimePicker
                value={timein}
                onChange={(newValue) => {
                  setTimeIn(newValue);
                  validateTime(newValue, 'timein');
                }}
                ampm={true}
                openTo="hours"
                views={['hours', 'minutes']}
                inputFormat="h:mm a"
                renderInput={(params) => (
                  <TextField 
                    {...params} 
                    variant="outlined"
                    size="small"
                    fullWidth
                    sx={{ mt: 1 }}
                    onClick={params.onClick}
                    inputProps={{
                      ...params.inputProps,
                      onKeyDown: (e) => {
                        // Allow numbers, colon, space, A, M, P and navigation keys
                        const allowedKeys = ['0','1','2','3','4','5','6','7','8','9',':',
                                           'a','A','m','M','p','P',' ',
                                           'Tab','ArrowLeft','ArrowRight','Backspace','Delete','Enter'];
                        if (!allowedKeys.includes(e.key)) {
                          e.preventDefault();
                        }
                      },
                      style: { cursor: 'pointer' }
                    }}
                    error={validationErrors.timein}
                    helperText={
                      timeinActive 
                        ? "No time-in record" 
                        : validationErrors.timein 
                          ? "Invalid time format (use: 7:30 AM)"
                          : "Enter time or click to select"
                    }
                    placeholder="7:30 AM"
                  />
                )}
                disabled={timeinActive}
              />
            </LocalizationProvider>
            <br/>
            <br/>
            Break-in: 
            <br/>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <TimePicker
                value={breakin}
                onChange={(newValue) => {
                  setBreakIn(newValue);
                  validateTime(newValue, 'breakin');
                }}
                ampm={true}
                openTo="hours"
                views={['hours', 'minutes']}
                inputFormat="h:mm a"
                renderInput={(params) => (
                  <TextField 
                    {...params} 
                    variant="outlined"
                    size="small"
                    fullWidth
                    sx={{ mt: 1 }}
                    onClick={params.onClick}
                    inputProps={{
                      ...params.inputProps,
                      onKeyDown: (e) => {
                        // Allow numbers, colon, space, A, M, P and navigation keys
                        const allowedKeys = ['0','1','2','3','4','5','6','7','8','9',':',
                                           'a','A','m','M','p','P',' ',
                                           'Tab','ArrowLeft','ArrowRight','Backspace','Delete','Enter'];
                        if (!allowedKeys.includes(e.key)) {
                          e.preventDefault();
                        }
                      },
                      style: { cursor: 'pointer' }
                    }}
                    error={validationErrors.breakin}
                    helperText={
                      breakinActive 
                        ? "No break-in record" 
                        : validationErrors.breakin 
                          ? "Invalid time format (use: 7:30 AM)"
                          : "Enter time or click to select"
                    }
                    placeholder="12:00 PM"
                  />
                )}
                disabled={breakinActive}
              />
            </LocalizationProvider>
            <br/>
            <br/>
            Break-out:
            <br/>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <TimePicker
                value={breakout}
                onChange={(newValue) => {
                  setBreakOut(newValue);
                  validateTime(newValue, 'breakout');
                }}
                ampm={true}
                openTo="hours"
                views={['hours', 'minutes']}
                inputFormat="h:mm a"
                renderInput={(params) => (
                  <TextField 
                    {...params} 
                    variant="outlined"
                    size="small"
                    fullWidth
                    sx={{ mt: 1 }}
                    onClick={params.onClick}
                    inputProps={{
                      ...params.inputProps,
                      onKeyDown: (e) => {
                        // Allow numbers, colon, space, A, M, P and navigation keys
                        const allowedKeys = ['0','1','2','3','4','5','6','7','8','9',':',
                                           'a','A','m','M','p','P',' ',
                                           'Tab','ArrowLeft','ArrowRight','Backspace','Delete','Enter'];
                        if (!allowedKeys.includes(e.key)) {
                          e.preventDefault();
                        }
                      },
                      style: { cursor: 'pointer' }
                    }}
                    error={validationErrors.breakout}
                    helperText={
                      breakoutActive 
                        ? "No break-out record" 
                        : validationErrors.breakout 
                          ? "Invalid time format (use: 7:30 AM)"
                          : "Enter time or click to select"
                    }
                    placeholder="1:00 PM"
                  />
                )}
                disabled={breakoutActive}
              />
            </LocalizationProvider>
            <br/>
            <br/>
            Time-out: 
            <br/>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <TimePicker
                value={timeout}
                onChange={(newValue) => {
                  setTimeOut(newValue);
                  validateTime(newValue, 'timeout');
                }}
                ampm={true}
                openTo="hours"
                views={['hours', 'minutes']}
                inputFormat="h:mm a"
                renderInput={(params) => (
                  <TextField 
                    {...params} 
                    variant="outlined"
                    size="small"
                    fullWidth
                    sx={{ mt: 1 }}
                    onClick={params.onClick}
                    inputProps={{
                      ...params.inputProps,
                      onKeyDown: (e) => {
                        // Allow numbers, colon, space, A, M, P and navigation keys
                        const allowedKeys = ['0','1','2','3','4','5','6','7','8','9',':',
                                           'a','A','m','M','p','P',' ',
                                           'Tab','ArrowLeft','ArrowRight','Backspace','Delete','Enter'];
                        if (!allowedKeys.includes(e.key)) {
                          e.preventDefault();
                        }
                      },
                      style: { cursor: 'pointer' }
                    }}
                    error={validationErrors.timeout}
                    helperText={
                      timeoutActive 
                        ? "No time-out record" 
                        : validationErrors.timeout 
                          ? "Invalid time format (use: 7:30 AM)"
                          : "Enter time or click to select"
                    }
                    placeholder="6:00 PM"
                  />
                )}
                disabled={timeoutActive}
              />
            </LocalizationProvider>
            <br/>
            <br/>
            <Button 
              sx={{mt: 5, width: "100%"}} 
              variant="contained" 
              onClick={handleEdit}
              disabled={!areAllTimesValid()}
            >
              Submit
            </Button>
          </DialogContent>
        </Dialog>
      </div>
      <div>
        <Dialog open={passwordDialog}>
          <AppBar sx={{ position: "relative" }}>
            <DialogTitle id="alert-dialog-title">
              Reset Password!
              <IconButton
                aria-label="close"
                onClick={handleClosePasswordDialog}
                sx={{
                  position: 'absolute',
                  right: 8,
                  top: 8,
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
          </AppBar>
          <DialogContent>
            {data 
              ? 
                data.Employee.displayName
              :
                ''
            }
            
            <br />
            <br />
            <TextField id="standard-basic" label="Enter new Password" variant="standard" value={password} onChange={(e)=>setPassword(e.target.value)} required/>
            <Button sx={{ml: 3, mt: 1}} variant="contained" onClick={handleChangePassword}>Submit</Button>
          </DialogContent>
        </Dialog> 
      </div>
    </>
  )
}